export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/line_art.f59e8f5.png";